import { useEffect } from "react";
import { useHistory } from "react-router";
// Components
import BannerOne from "../../components/BannerOne";


// Images
import partnerProgramLogo from '../../assets/img/partnerProgram/banner.png';

// Scss
import '../../assets/css/partnerProgram.scss';

function NewPartnerPortalAccounts() {

  let history = useHistory();

  useEffect(() => {
    canYouHaveAccess();


  }, []);

  const TITLE = "A new home for your Partner Portal";
  // const SUB_TITLE = "Check our new partner portal and start creating deals. if you are already register on this portal, you have already access to the new one." +
  //  "If you never register on this portal, please check the new partner portal and register there." +
  //  "Tier-2 partners will still need to use this portal to create PDRs. Just click login on the tab above.";
  const SUB_TITLE = <div>
    <div className="mb-3">
    As a leader in modernization we’re always looking for ways to innovate to ensure our partners – like you – 
    are getting the best experience. 
    <br></br>
    So, we’ve re-mastered the portal to give you improved access to sales tools to help 
    land and expand new deals, 
    <br></br>
    grow your expertise through our training, personalize and execute marketing programs, 
    and of course register those PDRs!
    </div>
    <br></br>
    Access and bookmark the new portal with your existing credentials.
    <br></br>

    </div>;
  const BUTTON_NAME = "Partner Portal";
  const BUTTON_LINK= "https://partners.dynatrace.com/";

//   Check our new partner portal !!!! (link para Zift)
// Already a registered user? Just use the same credentials on the new portal!
// Never registered? Register here and access the new portal easily!
// NOTE: Partners of the RFOs must still use this portal to create PDRs.

  return (
    <>
        <BannerOne bannerImage={partnerProgramLogo} title={TITLE} subTitle={SUB_TITLE} buttonName={BUTTON_NAME} buttonLink={BUTTON_LINK} withoutImage={true}/>
    </>
  );

  function canYouHaveAccess() {
    try {
      if (process.env.REACT_APP_PROTECT_PAGE === "true" && window.top?.location.host !== process.env.REACT_APP_ALLOW_API) {
        console.log("You shall not pass");
        history.push('/not-found');
      }
    } catch (err) {
      

    }
  }

}

export default NewPartnerPortalAccounts;

